module.exports = __webpack_public_path__ + "static/media/newlogo.36859165.svg";